// AgentSchema.js
export const agentFormSchema = [
  {
    id: "id",
    dataType: "integer",
    shownOnForm: false,
    label: "ID",
    value: 0,
    isRequired: false,
    fieldType: "textfield",
  },
  {
    id: "sc_code",
    dataType: "Text",
    shownOnForm: true,
    label: "SC Code",
    value: "",
    isRequired: true,
    maxChar: 30,
    fieldType: "textfield",
    pattern: /^[a-zA-Z0-9\-_]+$/,
    patternMessage: "Invalid SC Code. Use letters, numbers, - or _. Example: SC001-01",
  },
  {
    id: "name",
    dataType: "Text",
    shownOnForm: true,
    label: "Name",
    value: "",
    isRequired: true,
    maxChar: 120,
    fieldType: "textfield",
  },
  {
    id: "phone",
    dataType: "Text",
    shownOnForm: true,
    label: "Phone",
    value: "",
    isRequired: false,
    maxChar: 30,
    fieldType: "textfield",
  },
  {
    id: "email",
    dataType: "Text",
    shownOnForm: true,
    label: "Email",
    value: "",
    isRequired: false,
    maxChar: 191,
    fieldType: "textfield",
  },
  {
    id: "status",
    dataType: "Text",
    shownOnForm: true,
    label: "Status",
    value: "ACTIVE",
    isRequired: true,
    maxChar: 50,
    fieldType: "select",
    textValue: "label",
    valueKey: "value",
    options: () => [
      { value: "ACTIVE", label: "Active" },
      { value: "DISABLED", label: "Disabled" },
    ],
  },
  {
    id: "password",
    dataType: "Text",
    shownOnForm: true,
    label: "Password",
    value: "",
    isRequired: false,
    maxChar: 72,
    fieldType: "password", // if your SchemaDialogForm supports "password"
    // If it doesn't, use fieldType: "textfield" and set inputType in the renderer.
  },
];

export const agentRecord = {
  id: 0,
  sc_code: "",
  name: "",
  phone: "",
  email: "",
  status: "ACTIVE",
  password: "",
};
